import { useCallback, useEffect, useMemo, useRef, useState } from "react"

export default function useResponsive() {
  const observerRef = useRef(null)

  const [device, setDevice] = useState(DEVICE)
  const [width, setWidth] = useState(WIDTH)
  const [height, setHeight] = useState(HEIGHT)

  const [deviceHeight, setDeviceHeight] = useState(HEIGHT)

  const calculateScreen = useCallback((device, viewWidth = WIDTH) => {
    const { width, height } = ASPECT_RATIO[device]
    return (viewWidth * height) / width
  }, [])

  useEffect(() => {
    if (device && width) {
      setDeviceHeight(calculateScreen(device, width))
    }
  }, [device, width, calculateScreen])

  const heightResizer = useCallback(container => {
    const { height } = container.getBoundingClientRect() || {}
    if (height) {
      setHeight(currentHeight => {
        if (height >= currentHeight) return height + HEIGHT
        return currentHeight
      })
    }
  }, [])

  const handleDevice = useCallback((device = 'desktop', width) => {
    if (!width) width = device === 'desktop' ? WIDTH : MOBILE_WIDTH
    setDevice(device)
    setWidth(width)
  }, [])

  return useMemo(() => ({
    device,
    deviceOptions: DEVICE_OPTIONS,
    mobileOptions: MOBILE_OPTIONS,
    width,
    height,
    deviceHeight,
    handleDevice,
    setDevice,
    setWidth,
    setHeight,

    useHeightResizer: container => {
      useEffect(() => {
        if (container && !observerRef.current) {
          heightResizer(container)

          const mutationObserver = new MutationObserver(() => {
            heightResizer(container)
          })

          mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
          })

          observerRef.current = mutationObserver

          return () => {
            mutationObserver.disconnect()
            observerRef.current = null
          }
        }
      }, [container])
    },
  }), [device, width, height, deviceHeight, handleDevice, setDevice, setWidth, setHeight, heightResizer])
}

/** @type {'desktop' | 'mobile'} */
const DEVICE = 'desktop'

/** @type {number} */
const WIDTH = 1920

/** @type {number} */
const HEIGHT = 1080

const MOBILE_WIDTH = 320

const DEVICE_OPTIONS = [
  { label: "Mobile", value: "mobile" },
  { label: "Desktop", value: "desktop" },
  // { label: "Tablet", value: "tablet" },
]

const MOBILE_OPTIONS = [
  { label: "Extra Small", value: 320 }, // w-xs
  { label: "Small", value: 384 }, // w-sm
  { label: "Medium", value: 448 }, // w-md
  { label: "Large", value: 512 }, // w-lg
  { label: "Extra Large", value: 576 }, // w-xl
]

const ASPECT_RATIO = {
  desktop: { width: 16, height: 9 },
  mobile: { width: 9, height: 19 },
  // tablet: { width: 3, height: 4 },
}
